import { Dispatch, SetStateAction, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { useParams } from 'react-router-dom';
import { getCurrentlyReplacingAudio } from 'app/store/Releases/selectors';
import {
  fetchReleaseVersionEffect,
  handleReplaceAudioResetEffect,
  replaceVersionAudioEffect,
} from 'app/store/Releases/effects';

const WEBSOCKET_TIMEOUT_IN_SECONDS = 15;

export const useReplaceAudioVersion = (
  setPrimaryAudioFetching: Dispatch<SetStateAction<boolean>>
) => {
  const dispatch = useAppDispatch();
  const { guid, versionGuid } = useParams();
  const currentlyReplacingAudio = useAppSelector(getCurrentlyReplacingAudio);
  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout>();
  const isAudioReplacing = Boolean(
    currentlyReplacingAudio[versionGuid as string]
  );

  const replaceAudioVersion = async (audioGuid: string) => {
    try {
      await dispatch(replaceVersionAudioEffect({ audioGuid })).unwrap();
      setPrimaryAudioFetching(true);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      const id = setTimeout(() => {
        dispatch(
          handleReplaceAudioResetEffect({ versionGuid: versionGuid as string })
        );
      }, 1000 * WEBSOCKET_TIMEOUT_IN_SECONDS);
      setTimeoutId(id);
    } catch (e) {
      await dispatch(
        fetchReleaseVersionEffect({
          releaseGuid: guid,
          versionGuid: versionGuid as string,
        })
      );
    }
  };

  return { replaceAudioVersion, isAudioReplacing };
};
